module.exports = __webpack_public_path__ + "img/crif.7f41fc51.svg";